<template>
  <div class="not-found-container text-center py-5">
    <div class="message-icon mb-3">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    
    <h2 class="mb-3">Página Não Encontrada</h2>
    <p class="text-muted mb-4">A URL que você tentou acessar não existe ou foi removida.</p>
    
    <button @click="navigateBackOrHome" class="btn btn-color-site btn-lg btn-block">
      <i class="fa-solid fa-arrow-left me-2"></i> {{ buttonText }}
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'; // Importar onMounted
import { useRouter } from 'vue-router';

const router = useRouter();
const buttonText = ref('Voltar'); // Texto inicial do botão

// Verifica se há histórico de navegação
const hasHistory = () => {
  // O window.history.length é uma forma simples.
  // Uma checagem mais robusta pode envolver a rota atual ou se veio de um link interno.
  // Para a maioria dos casos, verificar se há mais de uma entrada no histórico é suficiente.
  return window.history.length > 1;
};

// Função para navegar de volta ou para a home
const navigateBackOrHome = () => {
  if (hasHistory()) {
    router.back();
  } else {
    router.push('/');
  }
};

// Atualiza o texto do botão baseado no histórico ao montar o componente
onMounted(() => {
  if (!hasHistory()) {
    buttonText.value = 'Ir para a Página Inicial';
  }
});
</script>

<style scoped>
/* Seus estilos CSS permanecem inalterados */
.not-found-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px);
  padding: 2rem;
  margin: 0 auto;
  min-width: 600px;
  text-align: center;
}

.message-icon {
  font-size: 4rem;
  color: var(--text-muted-color);
}

h2 {
  font-size: 1.5rem;
  color: var(--secondary-color);
  margin-bottom: 1.5rem;
}

p {
  font-size: 1rem;
  max-width: 350px;
  line-height: 1.5;
  color: var(--text-muted-color);
  margin-bottom: 2rem;
}

.btn-color-site {
  background-color: #ff69b4;
  border-color: #ff69b4;
  color: white;
  font-weight: 600;
  min-width: 50%;
}
.btn-color-site:hover {
  background-color: #d65a98;
  border-color: #d65a98;
  color: white;
}

@media (max-width: 767.98px) {
  .not-found-container {
    min-width: inherit;
  }
}

</style>